import { useMemo } from 'react';
import { DotLottieReact, Layout } from '@lottiefiles/dotlottie-react';

type AnimationProps = {
  loop?: boolean;
  autoplay?: boolean;
  animationData: string;
  visible: boolean;
  layout: Layout;
  className?: string;
};

const Animation = ({
  loop = true,
  autoplay = true,
  animationData,
  visible,
  className,
  layout,
}: AnimationProps) => {
  const parsedAnimationData = useMemo(() => JSON.parse(animationData), [animationData]);

  return (
    <DotLottieReact
      className={className}
      data={parsedAnimationData}
      autoplay={autoplay && visible}
      loop={loop}
      layout={layout}
    />
  );
};

export default Animation;
